import AppActions from './app-actions.js';
import WinnerActions from './winner-actions.js';
import WinnerHistoryActions from './winner-history-actions.js';
import WinnerExportActions from './winner-export-actions.js';

export default {
  ...AppActions,
  ...WinnerActions,
  ...WinnerHistoryActions,
  ...WinnerExportActions,
};
